/* eslint-disable no-undef */
import React, {useEffect} from 'react';
import {Helmet} from 'react-helmet';
import useReactRouter from 'use-react-router';

const NODE_ENV = process.env.NODE_ENV;
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const Page = (props: { title?: string, className?: string, children?: any, [x: string]: any; }) => {
  const {title, children, ...rest} = props;

  const router = useReactRouter();

  useEffect(() => {
    if (NODE_ENV !== 'production') {
      return;
    }

    if (window.gtag) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: router.location.pathname,
        page_name: title
      });
    }
  }, [title, router]);

  return (
    <div {...rest}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </div>
  );
};

export default Page;
